export const BedgeOutline = ({ text }: { text: string | number }) => {
  return (
    <span className="border border-gray-200 py-1 px-3 text-sm rounded-md">
      {text}
    </span>
  );
};
